import { THEME_COLORS } from '@theme/constants';
import styled from 'styled-components';
import LineBreaker from '../../common/LineBreaker';

const CaracteristicaCard = ({
    titulo,
    descripcion,
}) => {


    return (
        <View>
            <div className="caracteristica_content">
                <div className="caracteristica_titulo">
                    <LineBreaker titulo={titulo} capitalize={true} />
                    {descripcion && <span className="uppa white strong600" >{descripcion}  </span>}
                </div>
            </div>
        </View>
    )

}

export default CaracteristicaCard;

const View = styled.div`
  
    .caracteristica_content {
        padding: .6em;
        min-height: 6em;
        background-color: ${THEME_COLORS.light.primary.main};
        border-top: 6px solid ${THEME_COLORS.light.secondary.main};
        border-radius: 0 0 30pt 30pt;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items:center;
        text-align:center ;
        p{
            margin-bottom:0 ;
            color:${THEME_COLORS.light.primary.contrastText};
        }

    }

  
`

